import React from 'react';

/**
 * Tarpex.live brand lockup, rebuilt as inline SVG so it stays crisp at any
 * size and can invert for the dark sidebar without shipping two bitmaps.
 *
 * The mark is the shield from the logo: an emerald crest with a white inner
 * shield and a dark "T" counter-form, plus the small eyelet ring top-left —
 * a nod to a tarpaulin grommet.
 */

export const LogoMark = ({ size = 36 }) => {
  const id = React.useId();

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id={`${id}-shield`} x1="8" y1="4" x2="56" y2="60" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2FC46F" />
          <stop offset="0.52" stopColor="#00A651" />
          <stop offset="1" stopColor="#07682E" />
        </linearGradient>
        <linearGradient id={`${id}-cap`} x1="10" y1="6" x2="52" y2="20" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6BD69B" />
          <stop offset="1" stopColor="#0B8A3D" />
        </linearGradient>
      </defs>

      {/* Crest body */}
      <path
        d="M32 3.5 6.5 12.2v22.1C6.5 47.6 17.3 57.4 32 61.5c14.7-4.1 25.5-13.9 25.5-27.2V12.2L32 3.5Z"
        fill={`url(#${id}-shield)`}
      />
      {/* Folded top edge — the highlight band across the top of the logo */}
      <path
        d="M32 3.5 6.5 12.2c6.4 4 14.1 6.2 25.5 6.2s19.1-2.2 25.5-6.2L32 3.5Z"
        fill={`url(#${id}-cap)`}
      />
      {/* Inner white shield */}
      <path
        d="M32 12.6 14.6 18.5v15.6c0 9.2 7.3 15.9 17.4 18.8 10.1-2.9 17.4-9.6 17.4-18.8V18.5L32 12.6Z"
        fill="#FFFFFF"
      />
      {/* The T */}
      <path
        d="M21.4 21.9h21.2v6.9h-6.9v20.4c-1.5.9-2.5 1.3-3.7 1.7-1.2-.4-2.2-.8-3.7-1.7V28.8h-6.9v-6.9Z"
        fill="#06341A"
      />
      {/* Eyelet ring */}
      <circle cx="17.4" cy="12.6" r="3.5" fill="#FFFFFF" />
      <circle cx="17.4" cy="12.6" r="1.6" fill="#06341A" />
    </svg>
  );
};

const Logo = ({ size = 34, variant = 'dark', showMark = true }) => {
  // `variant` describes the surface behind the logo, not the logo itself.
  const wordColor = variant === 'light' ? '#FFFFFF' : '#06341A';
  const liveColor = variant === 'light' ? '#2FC46F' : '#00A651';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: size * 0.28 }}>
      {showMark && <LogoMark size={size} />}
      <span
        style={{
          fontWeight: 800,
          fontSize: size * 0.56,
          letterSpacing: '-0.02em',
          lineHeight: 1,
          color: wordColor,
          whiteSpace: 'nowrap',
        }}
      >
        TARPEX
        <span style={{ color: liveColor }}>.LIVE</span>
      </span>
    </div>
  );
};

export default Logo;
